'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _reactRhumb = require('react-rhumb');

var _reactRedux = require('react-redux');

var _BannerSection = require('pricing-pages-unified-ui/components/banners/BannerSection');

var _BannerSection2 = _interopRequireDefault(_BannerSection);

var _CurrencyPicker = require('pricing-pages-unified-ui/components/common/CurrencyPicker');

var _CurrencyPicker2 = _interopRequireDefault(_CurrencyPicker);

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _ProductsAndPlansNavIds2 = _interopRequireDefault(_ProductsAndPlansNavIds);

var _CustomerSupport = require('pricing-pages-unified-ui/static/js/components/common/CustomerSupport');

var _CustomerSupport2 = _interopRequireDefault(_CustomerSupport);

var _Faq = require('pricing-pages-unified-ui/static/js/components/common/Faq');

var _Faq2 = _interopRequireDefault(_Faq);

var _Question = require('pricing-pages-unified-ui/static/js/components/common/Question');

var _Question2 = _interopRequireDefault(_Question);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tracking = require('../constants/Tracking');

var _getUsageTracker = require('../utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Calculator = require('./calculator/Calculator');

var _Calculator2 = _interopRequireDefault(_Calculator);

var _HubCalcPlanSelectorTileContainer = require('./calculator/HubCalcPlanSelectorTileContainer');

var _HubCalcPlanSelectorTileContainer2 = _interopRequireDefault(_HubCalcPlanSelectorTileContainer);

var _HubCalcPriceDisplayTileContainer = require('./calculator/HubCalcPriceDisplayTileContainer');

var _HubCalcPriceDisplayTileContainer2 = _interopRequireDefault(_HubCalcPriceDisplayTileContainer);

var _HubSubtitle = require('./common/HubSubtitle');

var _HubSubtitle2 = _interopRequireDefault(_HubSubtitle);

var _StyledBlob = require('./common/StyledBlob');

var _StyledBlob2 = _interopRequireDefault(_StyledBlob);

var _TabLayout = require('./TabLayout');

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _HubTierInfo = require('./product-pages/HubTierInfo');

var _HubTierInfo2 = _interopRequireDefault(_HubTierInfo);

var _StandardProductPageTitle = require('./product-pages/StandardProductPageTitle');

var _StandardProductPageTitle2 = _interopRequireDefault(_StandardProductPageTitle);

var _PageContainer = require('./common/PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _HubInfoContainer = require('./common/HubInfoContainer');

var _HubInfoContainer2 = _interopRequireDefault(_HubInfoContainer);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

var _PhoneSupport = require('pricing-pages-unified-ui/components/common/PhoneSupport');

var _PhoneSupport2 = _interopRequireDefault(_PhoneSupport);

var _PhoneSupportFooter = require('pricing-pages-unified-ui/components/common/PhoneSupportFooter');

var _PhoneSupportFooter2 = _interopRequireDefault(_PhoneSupportFooter);

var _responsiveBreakpoints = require('pricing-pages-unified-ui/utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

var _FailedLoadBanner = require('pricing-pages-unified-ui/components/loading/FailedLoadBanner');

var _FailedLoadBanner2 = _interopRequireDefault(_FailedLoadBanner);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PhoneSupportWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'SalesHubPage__PhoneSupportWrapper'
})(['width:450px;margin:50px auto;', ''], _responsiveBreakpoints2.default.phone(_templateObject));

var SALES = _ProductsAndPlansNavIds2.default.SALES;


function SalesHubPage(_ref) {
  var purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  (0, _react.useEffect)(function () {
    (0, _getUsageTracker2.default)().track('pageView', {
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      subscreen: _Tracking.SUBSCREENS.SALES_HUB
    });
  }, []);

  return _react2.default.createElement(
    _TabLayout2.default,
    { selectedPrimaryTab: 'products', selectedSecondaryTab: 'sales' },
    _react2.default.createElement(
      _PageContainer2.default,
      { 'data-selenium-id': 'page-success' },
      purchaseMotionRequestStatus === _RequestStatusTypes2.default.SUCCEEDED && _react2.default.createElement(_reactRhumb.NavMarker, { name: 'SALES_PAGE' }),
      _react2.default.createElement(_CurrencyPicker2.default, null),
      _react2.default.createElement(_StyledBlob2.default, null),
      _react2.default.createElement(
        _HubInfoContainer2.default,
        null,
        _react2.default.createElement(_FailedLoadBanner2.default, {
          hasFailed: purchaseMotionRequestStatus === _RequestStatusTypes2.default.FAILED
        }),
        _react2.default.createElement(_StandardProductPageTitle2.default, { hub: SALES }),
        _react2.default.createElement(
          _HubSubtitle2.default,
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'pricing-pages.hubs.sales.description' })
        ),
        _react2.default.createElement(_BannerSection2.default, { hub: SALES, hasTitleComponent: true }),
        _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
          authedComponentLoader: function authedComponentLoader() {
            return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/product-pages/Mon153ComponentsContainer');
          }
        }),
        _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
          publicComponentLoader: function publicComponentLoader() {
            return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/banners/SignupBanner');
          },
          publicComponentProps: { hub: SALES }
        }),
        _react2.default.createElement(_HubTierInfo2.default, { hub: SALES }),
        _react2.default.createElement(
          PhoneSupportWrapper,
          null,
          _react2.default.createElement(_PhoneSupport2.default, {
            phoneSourceId: 'sales-middle',
            screen: _Tracking.SUBSCREENS.SALES_HUB
          })
        ),
        _react2.default.createElement(_Calculator2.default, {
          PlanSelectorComponent: _HubCalcPlanSelectorTileContainer2.default,
          PriceDisplayComponent: _HubCalcPriceDisplayTileContainer2.default
        }),
        _react2.default.createElement(_CustomerSupport2.default, null),
        _react2.default.createElement(
          _Faq2.default,
          null,
          _react2.default.createElement(_Question2.default, { questionKey: 'sales.salesIntegrateCRM' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'sales.salesIntegrateEmail' }),
          _react2.default.createElement(_Question2.default, {
            questionKey: 'sales.salesAvailableSupport',
            href: (0, _urls.getCommunityUrl)()
          }),
          _react2.default.createElement(_Question2.default, { questionKey: 'sales.salesPaidSeats' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'sales.salesEnterpriseCommitment' }),
          _react2.default.createElement(_FooterMicrocopy2.default, null)
        ),
        _react2.default.createElement(_PhoneSupportFooter2.default, {
          phoneSourceId: 'sales-footer',
          screen: _Tracking.SUBSCREENS.SALES_HUB
        })
      )
    )
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(SalesHubPage, 'sales'));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/SalesHubPage.js
// module id = 723
// module chunks = 3 4